export default __webpack_public_path__ + "static/media/ProductSans-Regular.0aabd86c.woff2";